<phx-addon *ngIf="phxAddonText; else dropdownTemplate">
  <span class="phx-date-picker-prefix-text">{{ phxAddonText }}</span>
</phx-addon>

<ng-template #dropdownTemplate>
  <phx-addon
    [phxSelectedOption]="phxAddonOptions && phxAddonOptions[phxAddonSelectedKey]"
    [phxDropdownTemplate]="dropdown"
    (phxOpenChanged)="dropdownChanged($event)"
    [phxOpen]="phxOpen"
  >
    <phx-dropdown cdkTrapFocus [cdkTrapFocusAutoCapture]="true" #dropdown>
      <phx-menu>
        <phx-menu-item
          #addonItem
          phxFocusableItem
          *ngFor="let item of phxAddonOptions | keyvalue"
          (click)="onAddonChanged(item.key)"
          (keydown)="onListKeydown($event, item.key)"
        >
          {{ item.value }}
        </phx-menu-item>
      </phx-menu>
    </phx-dropdown>
  </phx-addon>
</ng-template>
<ng-content select="phx-date-picker"></ng-content>
